
import LineString from 'ol/geom/LineString';
import { lineStringLength } from 'ol/geom/flat/length';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.map.openlayers.measureValues');

function calculateArea(geometry) {
    return geometry.getArea();
}

function calculateCoords(geometry) {
    const count = geometry.flatCoordinates.length / 2;
    let coords = [];

    for (let i = 0; i < count; i++) {
        coords.push({
            x: geometry.flatCoordinates[(i * 2) + 0],
            y: geometry.flatCoordinates[(i * 2) + 1],
            z: 0
        });
    }

    return coords;
}

function calculateId(geometry) {
    return geometry.ol_uid;
}

function calculateLength(geometry) {
    return geometry.getLength();
}

function calculateLengthXY(geometry) {
    return geometry.getLength();
}

function calculateLengthLastSegment(geometry) {
    let segmentLength = [];
    geometry.forEachSegment(function (a, b) {
        const segment = new LineString([a, b]);
        segmentLength.push(segment.getLength());
    });
    return (segmentLength.length > 0)
        ? segmentLength[segmentLength.length - 1]
        : 0;
}

function calculatePerimeter(geometry) {
    let flatCoords = geometry.getFlatCoordinates();

    return (flatCoords.length >= 4)
        ? lineStringLength(
            flatCoords, 0, flatCoords.length, 2
        )
        : 0;
}

function calculateMeasureValue(geometry, name) {
    switch (name) {
        case 'id': return calculateId(geometry);
        case 'length': return calculateLength(geometry);
        case 'lengthXY': return calculateLengthXY(geometry);
        case 'lengthLastSegment': return calculateLengthLastSegment(geometry);
        case 'area': return calculateArea(geometry);
        case 'perimeter': return calculatePerimeter(geometry);
        case 'coords': return calculateCoords(geometry);
        default:
            log.warn(`unknown measure value name: "${name}"`);
            return 0;
    }
}

export function calculateMeasureValuesInGeometry(geometry, valueNames) {
    let values = geometry.get('values') || {};
    if (!valueNames) {
        valueNames = Object.keys(values);
    }
    for (let name of valueNames) {
        values[name] = calculateMeasureValue(geometry, name);
    }
    geometry.set('values', values);
    return values;
}
